import { Component } from 'react';

import { diff } from 'deep-object-diff';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import GenericFormComponent from './GenericFormComponent';

import { replacePropsBasedOnPermissions } from './utils';

const FormComponent = reduxForm()(GenericFormComponent);

class GenericFormContainer extends Component {
  componentDidMount() {
    const { onLoad } = this.props;
    onLoad && onLoad(this.props);
  }

  componentWillUnmount() {
    const { onUnmount } = this.props;
    onUnmount && onUnmount(this.props);
  }

  formatFormValue = (value) => {
    if (value === null || value === undefined) {
      return null;
    }

    // check if value is an obj -> it's a select value
    if (typeof value === 'object' && value?.value) {
      return value?.value ?? value;
    }

    if (
      typeof value === 'object' &&
      !Array.isArray(value) &&
      Object.keys(value).length
    ) {
      const values = { ...value };
      const cleanValues = {};
      Object.keys(values).forEach((key) => {
        const value = values[key];
        cleanValues[key] = this.formatFormValue(value);
      });
      return cleanValues;
    }

    return value === '' ? null : value;
  };

  customSubmit = (formValues) => {
    const {
      onSubmit,
      submitChangedOnly, // can be set to 'true' by default when API is ready
      isUpdate,
      initialValues,
    } = this.props;
    const cleanValues = {};
    let values = formValues;
    if (isUpdate && submitChangedOnly) {
      values = diff(initialValues, formValues);
    }
    Object.keys(values).forEach((key) => {
      const value = values[key];
      cleanValues[key] = this.formatFormValue(value);
    });
    return onSubmit(cleanValues, this.props);
  };

  render() {
    const props = replacePropsBasedOnPermissions({
      ...this.props,
      customSubmit: this.customSubmit,
    });
    return <FormComponent {...props} />;
  }
}

GenericFormContainer.defaultProps = {
  onLoad: () => {},
  onUnmount: () => {},
  submitChangedOnly: false,
  isUpdate: false,
  initialValues: {},
};

GenericFormContainer.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onLoad: PropTypes.func,
  onUnmount: PropTypes.func,
  submitChangedOnly: PropTypes.bool,
  isUpdate: PropTypes.bool,
  initialValues: PropTypes.instanceOf(Object),
};

export default GenericFormContainer;
